import { DevicePreviewEnum } from '@lighthouse/core'
import { DEFAULT_DESKTOP_BREAK_POINT, useAtomData } from '@lighthouse/shared'
import { useAtomValue } from 'jotai'
import { useCallback } from 'react'

import {
    appAtom,
    appEnvListAtom,
    applicationModePageHistoryAtom,
    applicationPrivateTemplateAtom,
    applicationSettingAtom,
    appListAtom,
    currentAppIdAtom,
    currentAppVersionIdAtom,
    currentBreakPointAtom,
    currentBreakPointIdAtom,
    currentEnvIdAtom,
    languageAtom,
    mainBreakPointAtom
} from '@/atoms/application/state'

export const useCurrentAppId = () => {
    return useAtomValue(currentAppIdAtom)
}

export const useCurrentAppVersionId = () => {
    return useAtomValue(currentAppVersionIdAtom)
}

export const useCurrentEnvId = () => {
    return useAtomValue(currentEnvIdAtom)
}

export const useApplicationList = () => {
    return useAtomValue(appListAtom)
}

export const useApplicationModePageHistory = () => {
    return useAtomValue(applicationModePageHistoryAtom)
}

/**
 * Hook: 获取当前断点对象
 */
export const useCurrentBreakPoint = () => {
    return useAtomValue(currentBreakPointAtom)
}

export const useMainBreakPoint = () => {
    return useAtomValue(mainBreakPointAtom)
}

/**
 * Hook: 获取设备类型（管理端跟随当前断点的 type 属性）
 * 用于预览时模拟对应设备的 UI 组件样式
 */
export const useDeviceType = () => {
    const mainBreakPoint = useMainBreakPoint()
    const defaultDeviceType = mainBreakPoint === DEFAULT_DESKTOP_BREAK_POINT ? DevicePreviewEnum.DESKTOP : DevicePreviewEnum.MOBILE
    return useAtomValue(currentBreakPointAtom)?.type || defaultDeviceType
}

/**
 * Hook: 获取当前断点 ID
 */
export const useCurrentBreakPointId = () => {
    const mainBreakPoint = useMainBreakPoint()
    return useAtomValue(currentBreakPointIdAtom) || mainBreakPoint
}

export const useApplication = () => {
    return useAtomValue(appAtom)
}

export const useAppLanguageList = () => {
    return useAtomData(
        applicationSettingAtom,
        useCallback(s => s?.language.list ?? [], [])
    )
}

export const useLanguage = () => {
    return useAtomData(languageAtom)
}

export const useAppEnvList = () => {
    return useAtomData(appEnvListAtom)
}

export const useAppMainDomain = () => {
    return useAtomData(
        appAtom,
        useCallback(s => s.mainDomain, [])
    )
}
